<template>
    <div>
        <div class="main-button-bar">
            <el-row>
                <el-button type="primary" size="small" @click="showAddDialog">新增支出</el-button>
            </el-row>

            <el-row class="search-row">
                <el-select v-model="params.shopId" clearable placeholder="选择店铺" class="search-item">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.typeId" clearable placeholder="选择类型" class="search-item">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.status" clearable placeholder="选择状态" class="search-item">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-row>

            <el-row class="search-row">
                <el-date-picker
                    type="date"
                    placeholder="开始支出日期"
                    v-model="params.expendTimeStart"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="截止支出日期"
                    v-model="params.expendTimeEnd"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-input v-model="params.orderId" placeholder="关联订单" class="search-item"></el-input>

                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 170"
            class="taobao-expend-table"
        >
            <el-table-column prop="shopName" label="所属店铺" width="150"></el-table-column>
            <el-table-column prop="orderId" label="所属订单" width="150"></el-table-column>

            <el-table-column prop="cost" label="支出金额" width="100">
                <template slot-scope="expend">{{ $tools.parsecost(expend.row.cost, true)}}</template>
            </el-table-column>

            <el-table-column prop="typeName" label="支出类型" width="100"></el-table-column>

            <el-table-column prop="expendTime" label="支出日期" width="100">
                <template slot-scope="expend">{{ $tools.timestampToDay(expend.row.expendTime)}}</template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" width="300"></el-table-column>

            <el-table-column prop="creatorName" label="登记人" width="100"></el-table-column>

            <el-table-column prop="createTime" label="登记时间" width="180">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.createTime)}}</template>
            </el-table-column>

            <el-table-column prop="reviewerName" label="审核人" width="100"></el-table-column>

            <el-table-column prop="reviewTime" label="审核时间" width="180">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.reviewTime)}}</template>
            </el-table-column>

            <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="expend">
                    <el-tag type="success" v-if="expend.row.status == 'Y'">有效</el-tag>
                    <el-tag type="danger" v-if="expend.row.status == 'N'">无效</el-tag>
                    <el-tag type="wwarning" v-if="expend.row.status == 'W'">审核中</el-tag>
                    <el-tag type="danger" v-if="expend.row.status == 'F'">未通过</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.status == 'W'"
                        type="text"
                        size="small"
                        @click="withdraw(scope.row.id)"
                    >撤回</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
            :page-size.sync="params.size"
        ></el-pagination>

        <taobao-expend-create-dialog :show.sync="showDialog" @afterAdd="page"></taobao-expend-create-dialog>
    </div>
</template>

<script>
import TaobaoExpendCreateDialog from "./Taobao-expend-create-dialog.vue";
export default {
    components: { TaobaoExpendCreateDialog },
    data() {
        return {
            showDialog: false,
            shops: null,
            types: null,
            params: {
                typeId: null,
                shopId: null,
                status: null,
                orderId: null,
                expendTimeStart: null,
                expendTimeEnd: null,
                current: null,
                total: null,
            },
            records: null,
            status: [
                { id: "Y", name: "生效" },
                { id: "N", name: "无效" },
                { id: "W", name: "审核中" },
                { id: "F", name: "未通过" },
            ],
        };
    },
    methods: {
        getShop() {
            let _this = this;

            _this.$http.post(
                ["taobao/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                "none"
            );
        },

        getType() {
            let _this = this;

            _this.$http.post(
                ["taobao/expend/type/all"],
                [
                    function (data) {
                        _this.types = data;
                    },
                ],
                "none"
            );
        },
        page() {
            let _this = this;

            _this.$http.post(
                ["taobao/expend/mypage", _this.params],
                [
                    function (data) {
                        _this.records = data.records;
                        _this.params.total = data.total;
                    },
                ],
                ".taobao-expend-table"
            );
        },
        withdraw(id) {
            let _this = this;

            _this.$tConfirm.show("确认进行【废弃】操作？", function () {
                _this.$http.post(
                    ["taobao/expend/withdraw", { id: id }],
                    [
                        function (data) {
                            _this.page(1);
                        },
                    ],
                    ".taobao-expend-table"
                );
            });
        },
        showAddDialog() {
            this.showDialog = true;
        },
    },
    mounted() {
        this.getShop()
        this.getType();
        this.page(1);
    },
};
</script>

<style lang="scss">
</style>